import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        width: '100%'
    },
    rest: {
        minWidth: 130,
        width: '100%'
    }
}));